/* uses vendor/mobile-menu-pusha.js */
function initMobileMenu(){
  var h = document.querySelector("html");
  var b = document.querySelector("body");
  var btn = document.querySelector('.open-mobile-menu');
  var deskNav = document.querySelector("#site-navigation");
  var mobileMenuWrapper = document.querySelector(".mobile-menu-source");
  var pusher = document.querySelector(".pusha-panel--left");
  var ctaMobMenu = document.querySelector("#mobile-menu-cta");
  var socialList = document.querySelector(".mobile-social-list-source");


  // Init mobile menu functionality if there's an open button
  if( btn ) {
    // Clone items for menu if no items are in there
    if(deskNav && !mobileMenuWrapper.querySelector("ul"))  setMobileMenuItems(deskNav, mobileMenuWrapper);
    initUpdateMarkup(mobileMenuWrapper);
    initMenuWatchers();
    addMinHeightToWrapper();

    // remove source elements
    mobileMenuWrapper.parentElement.removeChild(mobileMenuWrapper);
    if(ctaMobMenu) ctaMobMenu.parentElement.parentElement.removeChild(ctaMobMenu.parentElement);
    if(socialList) socialList.parentElement.removeChild(socialList);
  }

  function initMenuWatchers(){
    // Div to close when menu is open
    var blocker = document.createElement("div");
    blocker.classList.add("pusha-blocker");
    b.appendChild(blocker);

    // Button to close when menu is open
    var buttonClose = document.createElement("button");
    buttonClose.classList.add("close-button");
    buttonClose.setAttribute('data-close', '');
    buttonClose.innerHTML = "<span class='show-for-sr'>Close Menu</span><span class='close-icon'></span>";
    var mWrapper = document.querySelector(".sm_menu_outer");
    if(mWrapper.querySelector("ul")){
      mWrapper.insertBefore(buttonClose, mWrapper.querySelector("ul"));
    }
    else{
      mWrapper.appendChild(buttonClose);
    }

    btn.addEventListener('click', 
      function(){
        if(!b.classList.contains("mmactive")){
          openMobileMenu();
          openSimpleMM();
        } 
      }
    );

    blocker.addEventListener('click', 
      function(){
        closeMobileMenu();
        closeSimpleMM();
      }
    );

    buttonClose.addEventListener('click', 
      function(){
        closeMobileMenu();
        closeSimpleMM();
      }
    );

    // Negate click on link that has children
    negateClick();
      
    function closeSimpleMM(){
      b.classList.remove("active");
      mWrapper.classList.remove("active");
    }
    function openSimpleMM(){
      b.classList.add("active");
      mWrapper.classList.add("active");
    }


    // Items with children should not trigger in here
    function negateClick(){
      var menu = document.querySelector(".sm_menu_outer");

      var hasChildren = menu.querySelectorAll(".menu-item-has-children > a");

      for(var i =0; i < hasChildren.length; i++){
        hasChildren[i].addEventListener('click', 
            function(e){
              e.preventDefault();
            }
          );
      }
    }
  }

  function openMobileMenu(){
    pusher.setAttribute('aria-hidden', 'false');
    pusher.classList.add('pusha-panel--active');
    h.classList.add('pusha-active');
  }

  function closeMobileMenu(){
    pusher.setAttribute('aria-hidden', 'true');
    pusher.classList.remove('pusha-panel--active');
    h.classList.remove('pusha-active');
  }

  function initUpdateMarkup(){
    var m = mobileMenuWrapper.querySelector("ul");
    m.classList.add("mobile_menu");

    jQuery(".mobile_menu").simpleMobileMenu({
      // Submenu Class
      "submenuClass"  : "sub-menu", 
      // or 'accordion'
      "menuStyle": "slide",
    });

    if(ctaMobMenu){
      // if a call to action exists
      var ul = document.querySelector(".mobile_menu");
      // email icon
      var svg = "<svg xmlns='http://www.w3.org/2000/svg' width='17.707' height='11.971' viewBox='0 0 17.707 11.971'>";
          svg+="<svg xmlns='http://www.w3.org/2000/svg' width='17.707' height='11.971' viewBox='0 0 17.707 11.971'>";
          svg+="<g id='Expanded' transform='translate(0.25 -7.75)'>";
          svg+="<g id='Group_826' data-name='Group 826' transform='translate(0 8)'>";
          svg+="<g id='Group_822' data-name='Group 822'>";
          svg+="<path id='Path_1839' data-name='Path 1839' d='M15.773,19.471H1.434A1.435,1.435,0,0,1,0,18.038v-8.6A1.435,1.435,0,0,1,1.434,8H15.773a1.435,1.435,0,0,1,1.434,1.434v8.6A1.435,1.435,0,0,1,15.773,19.471ZM1.434,8.717a.718.718,0,0,0-.717.717v8.6a.718.718,0,0,0,.717.717H15.773a.718.718,0,0,0,.717-.717v-8.6a.718.718,0,0,0-.717-.717Z' transform='translate(0 -8)' fill='#fff' stroke='#fff' stroke-width='0.5'/>";
          svg+="</g>";
          svg+="<g id='Group_823' data-name='Group 823' transform='translate(2.151 2.868)'>";
          svg+="<path id='Path_1840' data-name='Path 1840' d='M12.452,20.729,6.164,16.66a.359.359,0,0,1,.389-.6l5.9,3.817,5.9-3.817a.359.359,0,1,1,.389.6Z' transform='translate(-6 -16)' fill='#fff' stroke='#fff' stroke-width='0.5'/>";
          svg+=" </g>";
          svg+="<g id='Group_824' data-name='Group 824' transform='translate(1.792 6.452)'>";
          svg+="<path id='Path_1841' data-name='Path 1841' d='M5.358,28.867a.358.358,0,0,1-.2-.657L8.385,26.06a.359.359,0,0,1,.4.6L5.557,28.807A.36.36,0,0,1,5.358,28.867Z' transform='translate(-4.999 -25.999)' fill='#fff' stroke='#fff' stroke-width='0.5'/>";
          svg+="</g>";
          svg+="<g id='Group_825' data-name='Group 825' transform='translate(11.471 6.452)'>";
          svg+="<path id='Path_1842' data-name='Path 1842' d='M35.584,28.867a.36.36,0,0,1-.2-.06l-3.226-2.151a.359.359,0,0,1,.4-.6l3.226,2.151a.358.358,0,0,1-.2.657Z' transform='translate(-31.999 -25.999)' fill='#fff' stroke='#fff' stroke-width='0.5'/>";
          svg+=" </g>";
          svg+=" </g>";
          svg+="</g>";
          svg+="</svg>";

      if(ul){
        var lis = ctaMobMenu.querySelectorAll("li");

        for(var i=0; i< lis.length; i++){
          lis[i].classList.add("is-cta");
          if(i== 0) lis[i].classList.add("first-of-type");
          if(lis[i].classList.contains("has-email")) {
            var svgWrapper = document.createElement("span");
            svgWrapper.classList.add("is-icon");
            svgWrapper.classList.add("is-svg");
            
            svgWrapper.innerHTML = svg;
            var a = lis[i].querySelector("a");
            a.insertBefore(svgWrapper, a.firstChild);
          }
          ul.appendChild(lis[i]);
        }// for
      }// if ul
    }// if(ctaMobMenu){}
    
    if(socialList){
      // if a social list exists
      var dest = document.querySelector(".sm_menu_outer");
      var ul = socialList.querySelector("ul");
      
      if(ul) dest.appendChild(ul);
    }// if(socialList){}
  }// initUpdateMarkup()

  function setMobileMenuItems(nav, targetWrapper){
    var mobileList = document.createElement("ul");

    mobileList.innerHTML = nav.querySelector("ul").innerHTML;
    var liItems = mobileList.querySelectorAll("li");
    for(var i=0; i < liItems.length; i++){
      if(liItems[i].id){
        liItems[i].id = "mobile-"+liItems[i].id;
      }
    }
    targetWrapper.appendChild(mobileList);
  }
  function addMinHeightToWrapper(){
    var mobileWrapper = document.querySelector(".sm_menu_outer");
    if(mobileWrapper){
      addMinHtW();
      window.addEventListener('resize', addMinHtW);
    }
    function addMinHtW(){
      // We execute the same script as before
      var wh = Math.max(window.innerHeight, document.documentElement.clientHeight || 0)
      mobileWrapper.style.minHeight = wh+"px";
    }
  }
}

DOMReady(function() {
  initMobileMenu();
});